import React, { useEffect, useState, Fragment, useCallback } from "react";
import { themeStyle } from "../../components/Components.js";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import moment from "moment";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import DeleteIcon from "@mui/icons-material/Delete";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar.js";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { API_URL, MAIN_TITLE, alertMessage } from "../../actions/auth.js";
import { Bar } from "react-chartjs-2";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TextField from "@mui/material/TextField";
import Avatar from "@mui/material/Avatar";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import { Chart, registry } from "chart.js/auto";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Fab } from "@mui/material";
import Fade from "@mui/material/Fade";
import AddIcon from "@mui/icons-material/Add";
import PublishIcon from "@mui/icons-material/Publish";
import Drawer from "@mui/material/Drawer";
import Checkbox from "@mui/material/Checkbox";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import debounce from "lodash/debounce";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Calendar from "react-calendar";
import InventoryIcon from "@mui/icons-material/Inventory";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import PersonIcon from "@mui/icons-material/Person";

const colorList = [
  "#e5f5f9",
  "#e0ecf4",
  "#fee8c8",
  "#ece7f2",
  "#f0f0f0",
  "#fde0dd",
  "#efedf5",
  "#e5f5e0",
  themeStyle.primaryColorLight,
  "#fee6ce",
  "#e5f5f9",
  "#e0ecf4",
  "#fee8c8",
  "#ece7f2",
  "#f0f0f0",
  "#fde0dd",
  "#efedf5",
  "#e5f5e0",
  themeStyle.primaryColorLight,
  "#fee6ce",
];
const colorList2 = [
  "#2ca25f", // Green
  "#8856a7", // Purple
  "#e34a33", // Red
  "#1c9099", // Teal
  "#636363", // Gray
  "#c51b8a", // Pink
  "#756bb1", // Lavender
  "#31a354", // Dark Green
  "#e6550d", // Orange
  "#fd8d3c", // Light Orange
  "#6baed6", // Light Blue
  "#9e9ac8", // Light Purple
  "#a1d99b", // Mint Green
  "#bcbddc", // Pale Lavender
  "#f768a1", // Hot Pink
  "#7fcdbb", // Aqua
  "#253494", // Navy Blue
];

const colorList3 = [
  "#99d8c9",
  "#9ebcda",
  "#fdbb84",
  "#a6bddb",
  "#bdbdbd",
  "#fa9fb5",
  "#bcbddc",
  "#addd8e",
  "#9ecae1",
  "#a1d99b",
];

const weekday = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

function DashboardIT() {
  const dispatch = useDispatch();
  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);
  const [isLoading, setIsLoading] = useState(true);
  const [isReady, setIsReady] = useState(false);
  const [eventsList, setEventsList] = useState([]);
  const [rankersList, setRankersList] = useState([]);
  const [importantDatesList, setImportantDatesList] = useState([]);
  const [selectedNoti, setSelectedNoti] = useState("CLASS");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [holidayList, setHolidayList] = useState([]);
  const [teacherLeaveRequests, setTeacherLeaveRequests] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [open, setOpen] = useState(false);
  const [uploadAttachment, setUploadAttachment] = useState(false);
  const [institutionInfo, setInstitutionInfo] = useState({
    present: 0,
    absent: 0,
    late: 0,
    half: 0,
  });

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setSelectedDay(weekday[date.getDay()]);
  };

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedDay, setSelectedDay] = useState(weekday[new Date().getDay()]);

  const handleNotiSelect = (event) => {
    setSelectedNoti(event.currentTarget.value);
  };

  const handlePageSelect = (event) => {
    setSelectedPage(event.currentTarget.value);
  };

  const [assignmentList, setAssignmentList] = useState([]);
  const [importantDatesDateList, setImportantDatesDateList] = useState([]);
  const [holidayDateList, setHolidayDateList] = useState([]);
  const [eventsDateList, setEventsDateList] = useState([]);
  const [examDateList, setExamDateList] = useState([]);

  const [classList, setClassList] = useState([]);
  const [classs, setClass] = useState("");
  const [division, setDivision] = useState("");
  const [noticeFor, setNoticeFor] = useState("Everyone");

  function getNoticeForList() {
    var noticeForMenu = [
      "Everyone",
      "Teachers",
      "Parents",
      "Students",
      "Class",
      "Division",
    ].map((notiFor, index) => <MenuItem value={notiFor}>{notiFor}</MenuItem>);
    return noticeForMenu;
  }

  function getClassList() {
    var classes = Object.keys(classList).map((classs, index) => (
      <MenuItem value={classs}>{classs}</MenuItem>
    ));
    return classes;
  }

  function getDivisionList() {
    var classes = Object.keys(classList[classs]).map((division, index) => (
      <MenuItem value={division}>{division}</MenuItem>
    ));
    return classes;
  }

  function handleNoticeForChange(e) {
    setNoticeFor(e.target.value);
  }

  function handleClassChange(e) {
    setClass(e.target.value);
  }

  function handleDivisionChange(e) {
    setDivision(e.target.value);
  }

  const [selectedPage, setSelectedPage] = useState(
    params.get("tab") ? params.get("tab") : "HOME",
  );

  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [noticeBoard, setNoticeBoard] = useState({});
  const [search, setSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedSearch, setSelectedSearch] = useState("");

  function fileData() {
    if (selectedFile) {
      return (
        <div>
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <IconButton size="small">
              <CloseIcon
                onClick={() => setOpen(false)}
                style={{ color: themeStyle.primaryColor }}
              />
            </IconButton>
          </div>
          <h2>File Details:</h2>
          <p>File Name: {selectedFile.name}</p>
          <p>File Type: {selectedFile.type}</p>

          <br></br>
          <br></br>
          {selectedFile.size > 25 * 1024 * 1024 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  createAlert(
                    "ERROR",
                    "File too big.",
                    "File size should be less than 25 MB.",
                  );
                  setOpen(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD DOCUMENTS
              </Button>
            </div>
          ) : selectedFile.name.length >= 50 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  createAlert(
                    "ERROR",
                    "File name to obig.",
                    "File size should be less than 50 characters.",
                  );
                  setOpen(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD DOCUMENTS
              </Button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => onFileUpload()}
                style={{ backgroundColor: themeStyle.primaryColor }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD DOCUMENTS
              </Button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      );
    }
  }

  function onFileUpload() {
    setIsSubmitting(true);
    const formData = new FormData();

    formData.append("file", selectedFile, selectedFile.name);

    console.log(selectedFile);

    const config = {
      headers: {
        Authorization: state.auth.token,
      },
    };

    formData.append("name", name);
    formData.append("description", description);
    formData.append("institution_id", state.auth.user.institution_id);
    formData.append("date", moment(Date.now()).format("DD-MM-YYYY"));
    formData.append("class_id", classs);
    formData.append("division", division);
    formData.append("notice_for", noticeFor);

    axios
      .post(API_URL + "/add_notice_with_attachment", formData, config)
      .then(() => {
        getData();
        setIsSubmitting(false);
        setToggleDrawer(false);
        createAlert("SUCCESS", "Success.", "Notice added.");
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
      });

    setOpen(false);
    document.getElementById("contained-button-file").value = "";
  }

  function addNotice() {
    setIsSubmitting(true);
    var body = {};

    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };

    body["name"] = name;
    body["description"] = description;
    body["institution_id"] = state.auth.user.institution_id;
    body["date"] = moment(Date.now()).format("DD-MM-YYYY");
    body["class_id"] = classs;
    body["division"] = division;
    body["notice_for"] = noticeFor;

    body = JSON.stringify(body);

    axios
      .post(API_URL + "/add_notice", body, config)
      .then(() => {
        getData();
        setIsSubmitting(false);
        setToggleDrawer(false);
        createAlert("SUCCESS", "Success.", "Notice added.");
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
      });

    setOpen(false);
  }

  function deleteNotice(category, division, id) {
    setIsSubmitting(true);
    var body = {};

    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };

    body["institution_id"] = state.auth.user.institution_id;
    body["category"] = category;
    body["division"] = division;
    body["id"] = id;

    body = JSON.stringify(body);

    axios
      .post(API_URL + "/delete_notice", body, config)
      .then(() => {
        getData();
        setIsSubmitting(false);
        setToggleDrawer(false);
        createAlert("SUCCESS", "Success.", "Notice deleted.");
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
      });
  }

  function getData() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };
    body["institution_id"] = state.auth.user.institution_id;
    body = JSON.stringify(body);

    axios.post(API_URL + "/get_events_list", body, config).then((res) => {
      var tempEventsList = res.data["events_list"];
      var tempHolidayList = res.data["holidays_list"];
      var tempImportantDatesList = res.data["important_dates_list"];

      var tempEventsDateList = [];
      for (var i = 0; i < res.data["events_list"].length; i++) {
        tempEventsDateList.push(res.data["events_list"][i]["date"]);
      }
      setEventsDateList(tempEventsDateList);

      var tempHolidayDateList = [];
      for (var i = 0; i < res.data["holidays_list"].length; i++) {
        tempHolidayDateList.push(res.data["holidays_list"][i]["date"]);
      }
      setHolidayDateList(tempHolidayDateList);

      var tempImportantDatesDateList = [];
      for (var i = 0; i < res.data["important_dates_list"].length; i++) {
        tempImportantDatesDateList.push(
          res.data["important_dates_list"][i]["date"],
        );
      }
      setImportantDatesDateList(tempImportantDatesDateList);

      for (var i = res.data["events_list"].length - 1; i >= 0; i--) {
        if (
          moment(res.data["events_list"][i]["date"], "DD-MM-YYYY").isBefore(
            moment(),
          )
        ) {
          tempEventsList.splice(i, 1);
        }
      }

      setEventsList(tempEventsList);

      for (var i = res.data["holidays_list"].length - 1; i >= 0; i--) {
        if (
          moment(res.data["holidays_list"][i]["date"], "DD-MM-YYYY").isBefore(
            moment(),
          )
        ) {
          tempHolidayList.splice(i, 1);
        }
      }

      setHolidayList(tempHolidayList);

      for (var i = res.data["important_dates_list"].length - 1; i >= 0; i--) {
        if (
          moment(
            res.data["important_dates_list"][i]["date"],
            "DD-MM-YYYY",
          ).isBefore(moment())
        ) {
          tempImportantDatesList.splice(i, 1);
        }
      }

      setImportantDatesList(tempImportantDatesList);

      axios
        .post(API_URL + "/get_noticeboard_principal", body, config)
        .then((res) => {
          axios
            .post(API_URL + "/get_attendance_dashboard", body, config)
            .then((res) => {
              setInstitutionInfo(res.data);
              setIsLoading(false);
            });
          setNoticeBoard(res.data);
        });
    });
  }

  function onFileChange(event) {
    setSelectedFile(event.target.files[0]);
    setOpen(true);
  }

  function onFileClick(event) {
    document.getElementById("contained-button-file").value = "";
  }

  function getNoticeForMessage(noti) {
    if (noti == "Everyone") {
      return <span>Notice will be sent to everyone.</span>;
    } else if (noti == "Teachers") {
      return <span>Notice will be sent to all the teachers.</span>;
    } else if (noti == "Parents") {
      return <span>Notice will be sent to all the parents.</span>;
    } else if (noti == "Students") {
      return <span>Notice will be sent to all the students.</span>;
    } else if (noti == "Class") {
      return (
        <span>
          Notice will be sent to parents, students, teachers of {classs}.
        </span>
      );
    } else if (noti == "Division") {
      return (
        <span>
          Notice will be sent to parents, students, teachers of {classs}
          {division}
        </span>
      );
    }
  }

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      var body = {};
      const config = {
        headers: {
          Authorization: state.auth.token,

          "Content-Type": "application/json",
        },
      };
      body["institution_id"] = state.auth.user.institution_id;

      body = JSON.stringify(body);
      axios.post(API_URL + "/get_class_list", body, config).then((res) => {
        var classListTemp = res.data;
        setClassList(classListTemp);
        setClass(Object.keys(classListTemp)[0]);
        setDivision(
          Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0],
        );
        setIsReady(true);
        getData();
      });
    }
  }, []);

  const onSearch = (value) => {
    setSearch(value);
    handleSearch(value);
  };

  const handleSearch = useCallback(
    debounce((value) => {
      const config = {
        headers: {
          Authorization: state.auth.token,

          "Content-Type": "application/json",
        },
      };
      axios
        .get(
          API_URL +
            "/search_users?institution_id=" +
            state.auth.user.institution_id +
            "&search=" +
            value,
          config,
        )
        .then((res) => {
          console.log(res);

          setSearchResults(res.data);
        })
        .catch((err) => {
          setSearchResults([]);
        });
    }, 1000),
    [],
  );

  if (state.auth.refresh == "REFRESH_DATA") {
    getData();
    dispatch({ type: "REFRESH_DATA", payload: null });
  }

  var colorIndex = 0;

  const graphState = {
    dataLine: {
      labels: [
        "1st",
        "2nd",
        "3rd",
        "4th",
        "5th",
        "6th",
        "7th",
        "8th",
        "9th",
        "10th",
        "11th",
        "12th",
      ],
      datasets: [
        {
          label: "Students passed",
          fill: true,
          lineTension: 0.3,
          borderRadius: 100,
          borderSkipped: false,
          backgroundColor: "#084594",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          data: [65, 59, 80, 81, 56, 55, 40, 80, 81, 56, 55, 40],
          barThickness: 20,
        },
      ],
    },
  };

  function getContent() {
    if (selectedPage == "HOME") {
      return (
        <Grid
          container
          spacing={3}
          style={{ marginTop: "110px", marginLeft: "40px", width: "97%" }}
        >
          <Grid item md={9}>
            <Grid container spacing={8}>
              <Grid container spacing={3}>
                <Grid item md={3}>
                  <Link
                    style={{
                      textDecoration: "none",
                      color: themeStyle.primaryColor,
                    }}
                    to="/inventory"
                  >
                    <CardActionArea
                      style={{
                        height: "30vh",
                        backgroundColor: "#e7e6fb",
                        borderRadius: "15px",
                        marginBottom: "5px",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        padding: "20px",
                      }}
                    >
                      <PersonIcon
                        style={{ fontSize: "50px", color: colorList2[3] }}
                      />
                      <div>
                        <div
                          style={{
                            fontSize: "25px",
                            color: "black",
                          }}
                        >
                          Present
                        </div>

                        <div
                          style={{
                            marginTop: "10px",
                            fontSize: "53px",
                            marginBottom: "40px",
                            color: themeStyle.primaryColor,
                          }}
                        >
                          {institutionInfo["present"]}
                        </div>
                      </div>
                    </CardActionArea>
                  </Link>
                </Grid>
                <Grid item md={3}>
                  <Link
                    style={{
                      textDecoration: "none",
                      color: themeStyle.primaryColor,
                    }}
                    to="/inventory"
                  >
                    <CardActionArea
                      style={{
                        height: "30vh",
                        backgroundColor: "#f9e5ea",
                        borderRadius: "15px",
                        marginBottom: "5px",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        padding: "20px",
                      }}
                    >
                      <PersonIcon
                        style={{ fontSize: "50px", color: colorList2[4] }}
                      />
                      <div>
                        <div
                          style={{
                            fontSize: "25px",
                            color: "black",
                          }}
                        >
                          Absent
                        </div>

                        <div
                          style={{
                            marginTop: "10px",
                            fontSize: "53px",
                            marginBottom: "40px",
                            color: themeStyle.primaryColor,
                          }}
                        >
                          {institutionInfo["absent"]}
                        </div>
                      </div>
                    </CardActionArea>
                  </Link>
                </Grid>

                <Grid item md={3}>
                  <CardActionArea
                    style={{
                      height: "30vh",
                      backgroundColor: "#dfedf7",
                      borderRadius: "15px",
                      marginBottom: "5px",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      padding: "20px",
                    }}
                  >
                    <PersonIcon
                      style={{ fontSize: "50px", color: colorList2[5] }}
                    />
                    <div>
                      <div
                        style={{
                          fontSize: "25px",
                          color: "black",
                        }}
                      >
                        Late
                      </div>

                      <div
                        style={{
                          marginTop: "10px",
                          fontSize: "53px",
                          marginBottom: "40px",
                          color: themeStyle.primaryColor,
                        }}
                      >
                        {institutionInfo["late"]}
                      </div>
                    </div>
                  </CardActionArea>
                </Grid>
                <Grid item md={3}>
                  <CardActionArea
                    style={{
                      height: "30vh",
                      backgroundColor: "#fbedd9",
                      borderRadius: "15px",
                      marginBottom: "5px",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      padding: "20px",
                    }}
                  >
                    <PersonIcon
                      style={{ fontSize: "50px", color: colorList2[2] }}
                    />
                    <div>
                      <div
                        style={{
                          fontSize: "25px",
                          color: "black",
                        }}
                      >
                        Half-Day
                      </div>

                      <div
                        style={{
                          marginTop: "10px",
                          fontSize: "53px",
                          marginBottom: "40px",
                          color: themeStyle.primaryColor,
                        }}
                      >
                        {institutionInfo["half"]}
                      </div>
                    </div>
                  </CardActionArea>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={0} style={{ marginTop: "-15px" }}>
              <Grid item md={4} style={{ marginTop: "-5px" }}>
                <div style={{ marginLeft: "-60px", width: "107%" }}>
                  <Box
                    borderRadius="16px"
                    style={{
                      backgroundColor: colorList[0],
                      marginTop: "40px",
                    }}
                  >
                    <div className="calendar-container">
                      <Calendar
                        style={{
                          width: "100%",
                          backgroundColor: "black",
                        }}
                        onChange={handleDateChange}
                        value={selectedDate}
                        tileClassName={({ date, view }) => {
                          if (
                            eventsDateList.find(
                              (x) => x === moment(date).format("DD-MM-YYYY"),
                            )
                          ) {
                            return "highlightEvent";
                          } else if (
                            holidayDateList.find(
                              (x) => x === moment(date).format("DD-MM-YYYY"),
                            )
                          ) {
                            return "highlightHoliday";
                          } else if (
                            importantDatesDateList.find(
                              (x) => x === moment(date).format("DD-MM-YYYY"),
                            )
                          ) {
                            return "highlightImportant";
                          } else if (
                            examDateList.find(
                              (x) => x === moment(date).format("DD-MM-YYYY"),
                            )
                          ) {
                            return "highlightExam";
                          } else if (date.getDay() == 6) {
                            return "highlightSaturday";
                          }
                        }}
                      />
                    </div>
                  </Box>
                  <div
                    style={{
                      marginTop: "15px",
                      padding: 12,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <span
                      style={{
                        marginRight: "4px",
                        color: "white",
                        fontSize: "13px",
                        backgroundColor: "#6a6fff",
                        padding: "5px",
                        borderRadius: "20px",
                      }}
                    >
                      {" "}
                      Assignment
                    </span>
                    <span
                      style={{
                        marginRight: "4px",
                        color: "white",
                        fontSize: "13px",
                        backgroundColor: "#a1d99b",
                        padding: "5px",
                        borderRadius: "20px",
                      }}
                    >
                      {" "}
                      Exam
                    </span>

                    <span
                      style={{
                        marginRight: "4px",
                        color: "white",
                        fontSize: "13px",
                        backgroundColor: "#ff3333",
                        padding: "5px",
                        borderRadius: "20px",
                      }}
                    >
                      {" "}
                      Holiday
                    </span>

                    <span
                      style={{
                        marginRight: "4px",
                        color: "white",
                        fontSize: "13px",
                        backgroundColor: "#fa9fb5",
                        padding: "5px",
                        borderRadius: "20px",
                      }}
                    >
                      {" "}
                      Event
                    </span>

                    <span
                      style={{
                        marginRight: "4px",
                        color: "white",
                        fontSize: "13px",
                        backgroundColor: "#fdbb84",
                        padding: "5px",
                        borderRadius: "20px",
                      }}
                    >
                      {" "}
                      Important
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid
                item
                md={4}
                style={{ marginLeft: "-5px", marginTop: "15px" }}
              >
                <div
                  style={{
                    margin: "20px",
                    padding: "15px",
                    backgroundColor: themeStyle.primaryColorLight,
                    borderRadius: "25px",
                    marginRight: "5px",
                    marginLeft: "-5px",
                  }}
                >
                  {importantDatesList.length != 0 ? (
                    <h4
                      style={{
                        marginTop: "-5px",
                        marginLeft: "5px",
                        fontWeight: "bold",
                        color: themeStyle.primaryColor,
                        marginBottom: "-5px",
                      }}
                    >
                      Important dates
                    </h4>
                  ) : (
                    <Fragment>
                      <Link
                        to="/events"
                        style={{
                          textDecoration: "none",
                          color: "black",
                        }}
                      >
                        <div
                          style={{
                            margin: "20px",
                            display: "flex",
                            justifyContent: "center",
                            backgroundColor: "#dce1f7",
                            borderRadius: "15px",
                            alignItems: "center",
                            height: "95%",
                            width: "100%",
                          }}
                        >
                          <div style={{ textAlign: "center" }}>
                            <Fab
                              size="large"
                              style={{
                                border: "3px solid blue",
                                boxShadow: "none",
                                backgroundColor: "transparent",
                              }}
                              aria-label="add"
                            >
                              <PriorityHighIcon
                                style={{
                                  color: "blue",
                                }}
                              />
                            </Fab>
                            <br />
                            <h4 style={{ color: "black" }}>
                              No upcoming important dates.
                            </h4>

                            <div
                              style={{
                                color: "grey",
                                marginTop: "-25px",
                              }}
                            >
                              Click Here to go to events page.
                            </div>
                          </div>
                        </div>
                      </Link>
                    </Fragment>
                  )}
                  {importantDatesList.slice(0, 7).map((date, index) => (
                    <Link
                      key={index}
                      to="/events"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      <Box
                        border={1}
                        borderColor="#d2d2d2"
                        p={1}
                        fullWidth
                        borderRadius="16px"
                        style={{
                          display: "flex",
                          backgroundColor: colorList2[index],
                          color: "black",
                          justifyContent: "space-between",
                          marginTop: "15px",
                        }}
                        alignItems="center"
                      >
                        <p
                          style={{
                            fontSize: "15px",
                            margin: "-0px 0px 0px 12px",
                            width: "60%",
                            fontWeight: "bold",
                            color: "white",
                          }}
                        >
                          {date["name"]}
                        </p>
                        <div
                          style={{
                            margin: "-3px 10px 0px 0px",
                            color: "black",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "15px",
                              fontWeight: "bold",
                              color: "white",
                            }}
                          >
                            {moment(date["date"], "DD-MM-YYYY").format(
                              "Do MMM",
                            )}
                          </span>
                        </div>
                      </Box>
                    </Link>
                  ))}
                  <Link
                    to="/events"
                    style={{
                      textDecoration: "none",
                      color: "black",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "right",
                        color: themeStyle.primaryColor,
                      }}
                    >
                      <h4>More Important Dates...</h4>
                    </div>
                  </Link>
                </div>
              </Grid>{" "}
              <Grid
                item
                md={4}
                style={{
                  paddingRight: "25px",
                  paddingLeft: "20px",
                  marginTop: "15px",
                }}
              >
                <div
                  style={{
                    margin: "20px",
                    padding: "15px",
                    backgroundColor: themeStyle.primaryColorLight,
                    borderRadius: "25px",
                    marginRight: "-30px",
                    marginLeft: "-5px",
                  }}
                >
                  {holidayList.length != 0 ? (
                    <h4
                      style={{
                        marginTop: "-5px",
                        marginLeft: "5px",
                        fontWeight: "bold",
                        color: themeStyle.primaryColor,
                        marginBottom: "-5px",
                      }}
                    >
                      Holidays List
                    </h4>
                  ) : (
                    <Fragment>
                      <Link
                        to="/events"
                        style={{
                          textDecoration: "none",
                          color: "black",
                        }}
                      >
                        <div
                          style={{
                            margin: "20px",
                            display: "flex",
                            justifyContent: "center",
                            backgroundColor: "#dce1f7",
                            borderRadius: "15px",
                            alignItems: "center",
                            height: "95%",
                            width: "100%",
                          }}
                        >
                          <div style={{ textAlign: "center" }}>
                            <Fab
                              size="large"
                              style={{
                                border: "3px solid blue",
                                boxShadow: "none",
                                backgroundColor: "transparent",
                              }}
                              aria-label="add"
                            >
                              <PriorityHighIcon
                                style={{
                                  color: "blue",
                                }}
                              />
                            </Fab>
                            <br />
                            <h4 style={{ color: "black" }}>
                              No upcoming holidays.
                            </h4>

                            <div
                              style={{
                                color: "grey",
                                marginTop: "-25px",
                              }}
                            >
                              Click Here to go to events page.
                            </div>
                          </div>
                        </div>
                      </Link>
                    </Fragment>
                  )}
                  {holidayList.slice(0, 7).map((date, index) => (
                    <Link
                      key={index}
                      to="/events"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      <Box
                        border={1}
                        borderColor="#d2d2d2"
                        p={1}
                        fullWidth
                        borderRadius="16px"
                        style={{
                          display: "flex",
                          backgroundColor: colorList2[index],
                          color: "black",
                          justifyContent: "space-between",
                          marginTop: "15px",
                        }}
                        alignItems="center"
                      >
                        <p
                          style={{
                            fontSize: "15px",
                            margin: "-0px 0px 0px 12px",
                            width: "60%",
                            fontWeight: "bold",
                            color: "white",
                          }}
                        >
                          {date["name"]}
                        </p>
                        <div
                          style={{
                            margin: "-3px 10px 0px 0px",
                            color: "black",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "15px",
                              fontWeight: "bold",
                              color: "white",
                            }}
                          >
                            {moment(date["date"], "DD-MM-YYYY").format(
                              "Do MMM",
                            )}
                          </span>
                        </div>
                      </Box>
                    </Link>
                  ))}
                  <Link
                    to="/events"
                    style={{
                      textDecoration: "none",
                      color: "black",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        textAlign: "right",
                        color: themeStyle.primaryColor,
                      }}
                    >
                      <h4>More Holidays...</h4>
                    </div>
                  </Link>
                </div>
              </Grid>{" "}
            </Grid>
          </Grid>
          <Grid item md={3}>
            <div
              style={{
                marginTop: "-65px",
                width: "100%",
                borderRadius: "25px",
                padding: "25px",
                backgroundColor: themeStyle.primaryColorLight,
              }}
            >
              <div style={{ color: themeStyle.primaryColor, fontSize: "25px" }}>
                Recent Activity
              </div>
              <br />
              <div style={{ marginBottom: "15px" }}>
                <Typography
                  variant="subtitle1"
                  style={{
                    fontWeight: "bold",
                    fontFamily: "Campton Book",
                  }}
                >
                  Your Activity Details will be shown here
                </Typography>
              </div>
            </div>
            <Link to="/support" style={{ textDecoration: "none" }}>
              <div
                style={{
                  marginTop: "25px",
                  height: "32vh",
                  borderRadius: "15px",
                  backgroundColor: themeStyle.secondaryColor,
                  padding: "20px",
                }}
              >
                <div
                  style={{
                    color: "white",
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  Need help? Feel free to contact us for support!
                </div>
                <Button
                  style={{
                    fontSize: "15px",
                    height: "35px",
                    marginTop: "10px",
                    backgroundColor: themeStyle.primaryColor,
                  }}
                  fullWidth
                  variant="contained"
                  component="span"
                >
                  <h4>Help Center</h4>
                </Button>
                <img
                  style={{
                    height: "20vh",
                    marginLeft: "30px",
                    marginTop: "-15px",
                  }}
                  src={require("../../img/support.png")}
                ></img>
              </div>
            </Link>
          </Grid>
        </Grid>
      );
    } else {
      return (
        <Fragment>
          <Fab
            size="large"
            style={{
              boxShadow: "none",
              backgroundColor: "#ff3333 ",
              position: "fixed",
              bottom: 30,
              right: 30,
            }}
            onClick={() => setToggleDrawer(true)}
            aria-label="add"
          >
            <PublishIcon
              style={{
                color: "white",
              }}
            />
          </Fab>
          <Drawer
            anchor={"right"}
            open={toggleDrawer}
            onClose={() => setToggleDrawer(false)}
          >
            {isSubmitting ? (
              <div
                style={{
                  borderRadius: "15px",
                  marginTop: "60px",
                  padding: "20px",
                  width: "400px",
                  backgroundColor: "white",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <CircularProgress />
                <h3>Uploading in progress...</h3>
              </div>
            ) : (
              <div
                style={{
                  marginTop: "40px",
                  padding: "20px",
                  width: "400px",
                }}
              >
                <span
                  style={{
                    color: themeStyle.primaryColor,

                    fontSize: "14px",
                  }}
                >
                  Notice For
                </span>
                <Select
                  value={noticeFor}
                  onChange={(e) => handleNoticeForChange(e)}
                  style={{
                    marginTop: "2px",

                    height: "40px",
                  }}
                  fullWidth
                  variant={"outlined"}
                >
                  {getNoticeForList()}
                </Select>
                {noticeFor == "Class" || noticeFor == "Division" ? (
                  <Fragment>
                    <span
                      style={{
                        marginTop: "2px",

                        color: themeStyle.primaryColor,

                        fontSize: "14px",
                      }}
                    >
                      Class
                    </span>
                    <Select
                      value={classs}
                      onChange={(e) => handleClassChange(e)}
                      style={{
                        marginTop: "2px",
                        height: "40px",
                        marginBottom: "5px",
                      }}
                      fullWidth
                      variant={"outlined"}
                    >
                      {getClassList()}
                    </Select>
                  </Fragment>
                ) : (
                  <span></span>
                )}
                {noticeFor == "Division" ? (
                  <Fragment>
                    <span
                      style={{
                        color: themeStyle.primaryColor,

                        fontSize: "14px",
                      }}
                    >
                      Division
                    </span>
                    <Select
                      value={division}
                      onChange={(e) => handleDivisionChange(e)}
                      style={{
                        marginTop: "2px",
                        height: "40px",
                        marginBottom: "5px",
                      }}
                      fullWidth
                      variant={"outlined"}
                    >
                      {getDivisionList()}
                    </Select>
                  </Fragment>
                ) : (
                  <span></span>
                )}
                <div
                  style={{
                    marginTop: "5px",

                    color: themeStyle.primaryColor,

                    fontSize: "14px",
                  }}
                >
                  Title
                </div>
                <TextField
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  fullWidth
                  size="small"
                  style={{
                    marginTop: "2px",
                    height: "40px",
                    marginBottom: "5px",
                  }}
                  variant={"outlined"}
                  placeholder="Notice Title"
                />
                <span
                  style={{
                    color: themeStyle.primaryColor,

                    fontSize: "14px",
                  }}
                >
                  Description
                </span>
                <TextField
                  value={description}
                  style={{
                    marginTop: "2px",
                    height: "40px",
                    marginBottom: "5px",
                  }}
                  onChange={(e) => setDescription(e.target.value)}
                  fullWidth
                  placeholder="Description"
                  variant="outlined"
                  multiline
                  rows={4}
                />
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <Checkbox
                  labelStyle={{ color: themeStyle.primaryColor }}
                  iconStyle={{ fill: "white" }}
                  inputStyle={{ color: themeStyle.primaryColor }}
                  style={{
                    margin: "0px 0px 2px -12px",
                    color: themeStyle.primaryColor,
                  }}
                  checked={uploadAttachment}
                  onChange={(e) => setUploadAttachment(e.target.checked)}
                  value={1}
                  color={"primary"}
                />
                <span
                  style={{
                    color: themeStyle.primaryColor,

                    fontSize: "14px",
                  }}
                >
                  Upload attachment
                </span>
                <br></br>
                <span
                  style={{
                    color: "#ff3333",

                    fontSize: "14px",
                  }}
                >
                  {getNoticeForMessage(noticeFor)}
                </span>
                <br></br>
                <br></br>
                <Box
                  style={{
                    width: "100%",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  {" "}
                  {uploadAttachment ? (
                    <label
                      style={{ width: "100%" }}
                      htmlFor="contained-button-file"
                    >
                      <input
                        style={{ display: "none", width: "100%" }}
                        id="contained-button-file"
                        type="file"
                        onChange={(e) => onFileChange(e)}
                      />

                      <Button
                        style={{
                          fontSize: "15px",
                          height: "35px",
                          marginTop: "-1px",
                          backgroundColor: themeStyle.primaryColor,
                        }}
                        fullWidth
                        variant="contained"
                        component="span"
                      >
                        <h4>Send Notice</h4>
                      </Button>
                    </label>
                  ) : (
                    <Button
                      onClick={() => addNotice()}
                      fullWidth
                      style={{
                        fontSize: "15px",
                        height: "35px",
                        marginTop: "-1px",
                        backgroundColor: themeStyle.primaryColor,
                      }}
                      variant="contained"
                    >
                      <h4>Send Notice</h4>
                    </Button>
                  )}
                </Box>
              </div>
            )}
          </Drawer>
          <div style={{ marginTop: "75px" }}>
            {Object.keys(noticeBoard).map((category) =>
              category == "everyone" ||
              category == "parents" ||
              category == "teachers" ||
              category == "students" ? (
                <Fragment>
                  {noticeBoard[category].length != 0 ? (
                    <Fragment>
                      <h2>
                        For{" "}
                        {category.charAt(0).toUpperCase() + category.slice(1)}
                      </h2>
                      <Grid container spacing={1.5}>
                        {noticeBoard[category].map((noti, index) => (
                          <Grid item md={3}>
                            <Box
                              padding={1}
                              borderRadius="5px"
                              sx={{ "&:hover": { opacity: "1 !important" } }}
                              style={{
                                borderRadius: "15px",
                                backgroundColor: colorList[index],
                                boxShadow: "none",
                                height: "100%",
                                marginBottom: "5px",
                              }}
                            >
                              <Box style={{ marginLeft: "5px" }}>
                                <Grid
                                  container
                                  spacing={2}
                                  justifyContent="space-between"
                                >
                                  <Grid item md={10}>
                                    <div
                                      style={{
                                        color: themeStyle.secondaryColor,
                                        fontSize: "19px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {noti["title"]}
                                    </div>
                                    <div
                                      style={{
                                        color: themeStyle.primaryColor,
                                        fontSize: "15px",
                                      }}
                                    >
                                      {moment(
                                        noti["date"],
                                        "DD-MM-YYYY",
                                      ).format("Do MMMM, YYYY")}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "15px",
                                        color: "#ddd",
                                      }}
                                    >
                                      {noti["venue"]}
                                    </div>
                                    <div
                                      style={{
                                        margin: "10px 0px 0px 0px",
                                        fontSize: "15px",
                                        color: "black",
                                      }}
                                    >
                                      {noti["desc"]}
                                    </div>
                                  </Grid>
                                </Grid>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  {Object.keys(noti).includes("link") ? (
                                    <a
                                      href={noti["link"]}
                                      target="_blank"
                                      style={{
                                        margin: "15px 0px 0px 0px",
                                        fontSize: "15px",
                                        color: "white",
                                        fontWeight: "bold",
                                        backgroundColor:
                                          themeStyle.secondaryColor,
                                        padding: "5px 10px 5px 10px",
                                        borderRadius: "50px",
                                        textDecoration: "none",
                                      }}
                                    >
                                      View Document
                                    </a>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </Box>
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    </Fragment>
                  ) : (
                    <h3>No notices issued for {category}.</h3>
                  )}
                </Fragment>
              ) : (
                <Fragment>
                  {Object.keys(noticeBoard[category]).map((divi) => (
                    <Fragment>
                      {noticeBoard[category][divi].length != 0 ? (
                        <Fragment>
                          <h4>
                            {category.charAt(0).toUpperCase() +
                              category.slice(1) +
                              " " +
                              divi}
                          </h4>
                          <Grid container spacing={1.5}>
                            {noticeBoard[category][divi].map((noti, index) => (
                              <Grid item md={3}>
                                <Box
                                  padding={1}
                                  borderRadius="5px"
                                  sx={{
                                    "&:hover": { opacity: "1 !important" },
                                  }}
                                  style={{
                                    borderRadius: "6px",
                                    border:
                                      "2px solid " +
                                      themeStyle.primaryColorLight,
                                    backgroundColor: "white",
                                    boxShadow: "none",
                                    height: "100%",
                                    marginBottom: "5px",
                                  }}
                                >
                                  <Box style={{ marginLeft: "5px" }}>
                                    <Grid
                                      container
                                      spacing={2}
                                      justifyContent="space-between"
                                    >
                                      <Grid item md={10}>
                                        <div
                                          style={{
                                            color: themeStyle.secondaryColor,
                                            fontSize: "19px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {noti["title"]}
                                        </div>
                                        <div
                                          style={{
                                            fontSize: "15px",
                                            color: "grey",
                                          }}
                                        >
                                          {moment(
                                            noti["date"],
                                            "DD-MM-YYYY",
                                          ).format("Do MMMM, YYYY")}
                                        </div>
                                        <div
                                          style={{
                                            fontSize: "15px",
                                          }}
                                        >
                                          {noti["venue"]}
                                        </div>
                                        <div
                                          style={{
                                            margin: "10px 0px 0px 0px",
                                            fontSize: "15px",
                                          }}
                                        >
                                          {noti["desc"]}
                                        </div>
                                        {Object.keys(noti).includes("link") ? (
                                          <a
                                            href={noti["link"]}
                                            target="_blank"
                                            style={{
                                              margin: "10px 0px 0px 0px",
                                              fontSize: "15px",
                                              textDecoration: "none",
                                              color: colorList[1],
                                            }}
                                          >
                                            View Document
                                          </a>
                                        ) : (
                                          ""
                                        )}
                                      </Grid>
                                      <Grid item md={2}>
                                        <Button
                                          style={{
                                            borderRadius: "50px",
                                            marginTop: "-10px",

                                            height: "50px",
                                            width: "50px",
                                          }}
                                          onClick={() => {
                                            deleteNotice(
                                              category,
                                              divi,
                                              noti["id"],
                                            );
                                          }}
                                        >
                                          <DeleteIcon
                                            style={{
                                              color: "#ff3333",
                                            }}
                                          />
                                        </Button>
                                      </Grid>
                                    </Grid>
                                  </Box>
                                </Box>
                              </Grid>
                            ))}
                          </Grid>
                        </Fragment>
                      ) : (
                        <span></span>
                      )}
                    </Fragment>
                  ))}
                </Fragment>
              ),
            )}
          </div>
        </Fragment>
      );
    }
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (state.auth.user.is_attendance) {
        if (isLoading || !isReady) {
          return (
            <Fragment>
              <Sidebar />
              <div
                style={{
                  borderRadius: "15px",
                  maxWidth: "88vw",
                  marginTop: "45vh",
                  marginLeft: "8vw",
                  backgroundColor: "white",
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            </Fragment>
          );
        } else {
          return (
            <Fragment>
              <Sidebar
                tabs={
                  <Grid container spacing={1.5} justifyContent={"flex-end"}>
                    <Grid item md={4}>
                      {selectedPage == "HOME" ? (
                        <Button
                          fullWidth
                          value={"HOME"}
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColor,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "17px",
                              fontSize: "15px",
                            }}
                          >
                            HOME
                          </h3>
                        </Button>
                      ) : (
                        <Button
                          fullWidth
                          value={"HOME"}
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColorLight,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "17px",
                              fontSize: "15px",
                              color: themeStyle.secondaryColor,
                            }}
                          >
                            HOME
                          </h3>
                        </Button>
                      )}
                    </Grid>
                    <Grid item md={4}>
                      {selectedPage == "NOTICEBOARD" ? (
                        <Button
                          fullWidth
                          value="NOTICEBOARD"
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColor,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "17px",
                              fontSize: "15px",
                            }}
                          >
                            NOTICEBOARD
                          </h3>
                        </Button>
                      ) : (
                        <Button
                          fullWidth
                          value="NOTICEBOARD"
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColorLight,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "17px",
                              fontSize: "15px",
                              color: themeStyle.secondaryColor,
                            }}
                          >
                            NOTICEBOARD
                          </h3>
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                }
              />
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={() => setOpen(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open}>
                  <div
                    style={{
                      borderRadius: "15px",
                      position: "absolute",
                      top: "50%",
                      backgroundColor: "white",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 400,
                      padding: "20px",
                    }}
                  >
                    {fileData()}
                  </div>
                </Fade>
              </Modal>
              <div
                style={{
                  borderRadius: "15px",
                  margin: "37px 10px 20px 90px",
                  backgroundColor: "white",
                }}
              >
                {getContent()}
              </div>
            </Fragment>
          );
        }
      } else {
        createAlert(
          "ERROR",
          "Permission denied.",
          "Please Login With an Inventory Account",
        );
        dispatch({
          type: "AUTH_ERROR",
        });
        dispatch({ type: "AUTH_ERROR" });
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          borderRadius: "15px",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default DashboardIT;
